import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import CompactBookingCard from './bookings/CompactBookingCard';
import { clientPortalApi } from '../../lib/http';

const NextBookingsSection: React.FC = () => {
  const navigate = useNavigate();

  const { data: bookings, isLoading, refetch } = useQuery({
    queryKey: ['client-bookings-preview'],
    queryFn: async () => {
      const response = await clientPortalApi.bookings.list('upcoming');
      // Ensure we have an array and get only the first 3 bookings
      const bookingsArray = Array.isArray(response.data) ? response.data : [];
      return bookingsArray.slice(0, 3);
    },
    staleTime: 1 * 60 * 1000, // 1 minute
    refetchOnWindowFocus: true,
  });

  if (isLoading) {
    return (
      <section className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 sm:p-5">
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-base font-semibold text-gray-900">My Next Bookings</h2>
        </div>
        <div className="space-y-2">
          {[...Array(2)].map((_, i) => (
            <div key={i} className="h-[76px] bg-gray-50 rounded-xl animate-pulse" />
          ))}
        </div>
      </section>
    );
  }

  if (!bookings || bookings.length === 0) {
    return (
      <section className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 sm:p-5">
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-base font-semibold text-gray-900">My Next Bookings</h2>
          <button
            onClick={() => navigate('/u/bookings')}
            className="text-xs text-purple-600 hover:text-purple-700 font-medium transition-colors px-2 py-1 hover:bg-purple-50 rounded-lg cursor-pointer"
          >
            View All
          </button>
        </div>
        <div className="text-center py-8">
          <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-gray-100 flex items-center justify-center">
            <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
          <p className="text-sm font-medium text-gray-900">No upcoming bookings</p>
          <p className="text-xs text-gray-500 mt-1">Book with experts to see them here</p>
        </div>
      </section>
    );
  }

  return (
    <section className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 sm:p-5">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-base font-semibold text-gray-900">My Next Bookings</h2>
        {bookings.length > 0 && (
          <button
            onClick={() => navigate('/u/bookings')}
            className="text-xs text-purple-600 hover:text-purple-700 font-medium transition-colors px-2 py-1 hover:bg-purple-50 rounded-lg cursor-pointer"
          >
            View All
          </button>
        )}
      </div>
      <div className="space-y-2">
        {bookings.map((booking) => (
          <CompactBookingCard key={booking.id} booking={booking} />
        ))}
      </div>
    </section>
  );
};

export default NextBookingsSection;
